import { Theme } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => createStyles({
    input: {
        "& .MuiInputBase-root": {
            backgroundColor: theme.palette.common.white,
        },
    },
    multilineInput: {
        backgroundColor: theme.palette.common.white,
        borderRadius: 6,
    },
}));

export default useStyles;
